export const FAVOURITES_ERROR_GROUPS = {
  CHANGE_VARIANT: 'CHANGE_VARIANT',
  SAME_VARIANT: 'SAME_VARIANT',
  REMOVE: 'REMOVE',
}

export const FAVOURITES_ERROR_DISPLAY_MODE = {
  RENDER_MODAL: {
    isModal: true,
  },
  RENDER_NOTIFICATION_BAR: {
    isNotificationBar: true,
  },
}

export const STYLEBOARDS = {
  CREATE_IMAGE:
    "data:image/svg+xml,%3Csvg preserveAspectRatio='none' width='196' height='140' viewBox='0 0 196 140' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='0.566895' y='0.5' width='194.171' height='139' fill='white' stroke='%23707070' stroke-dasharray='4 4'/%3E%3Crect x='7.22998' y='7.27246' width='86.8421' height='125.455' fill='%23C4C4C4' fill-opacity='0.2'/%3E%3Crect x='101.235' y='7.27246' width='86.8421' height='59.0909' fill='%23C4C4C4' fill-opacity='0.2'/%3E%3Crect x='101.235' y='73.6362' width='86.8421' height='59.0909' fill='%23C4C4C4' fill-opacity='0.2'/%3E%3C/svg%3E%0A",
}

export const BRAND_OTHER_STORIES = 'otherStories'
